// extracted by mini-css-extract-plugin
export default {"root":"_2oafkPiY","total":"_12ZB01mX","button":"_1f4GJwJL","expanded":"_1F5LCL4S","list":"_1NH-7hdB"};